import classNames from 'classnames';

const Placeholder = () => (
  <>
    <div className="flex items-center gap-x-4">
      <div className="hidden space-y-2 lg:block">
        {[1, 2, 3, 4, 5].map(() => (
          <div className="h-12 w-12 animate-pulse rounded-md bg-gray-700/5" />
        ))}
      </div>
      <div className="h-[250px] w-full animate-pulse rounded-md bg-gray-700/5 md:h-[300px] lg:h-[350px]" />
    </div>
    <div className="mx-auto mt-4 flex items-center justify-center gap-x-2 lg:hidden">
      {[1, 2, 3, 4, 5].map((_image, i) => (
        <button
          key={i}
          className={classNames(
            'h-3 w-3 rounded-full border focus:outline-none',
            {
              'border-[#d3d3d3] hover:bg-[#d3d3d3]': i !== 0,
              'border-[#757575] bg-[#757575]': i === 0,
            },
          )}
        />
      ))}
    </div>
  </>
);

export default Placeholder;
